document.querySelectorAll("[data-product-section]").forEach((section) => {
  const gallery = section.querySelector("[data-gallery]");
  const items = [...gallery.querySelectorAll("[data-media-id]")];
  const activate = (id) => {
    items.forEach((item) => {
      item.hidden = item.dataset.mediaId !== id;
      if (item.hidden)
        item.querySelectorAll("video").forEach((video) => video.pause());
    });
    section.querySelectorAll("[data-media-target]").forEach((link) => {
      if (link.dataset.mediaTarget === id)
        link.setAttribute("aria-current", "true");
      else link.removeAttribute("aria-current");
    });
  };
  const initial =
    items.find((item) => item.hasAttribute("data-selected")) || items[0];
  if (initial) activate(initial.dataset.mediaId);
  section.querySelectorAll("[data-media-target]").forEach((link) =>
    link.addEventListener("click", (event) => {
      event.preventDefault();
      activate(link.dataset.mediaTarget);
    }),
  );
  const dialog = document.querySelector("[data-image-dialog]");
  let opener;
  if (dialog && typeof dialog.showModal === "function") {
    section.querySelectorAll("[data-zoom-link]").forEach((link) =>
      link.addEventListener("click", (event) => {
        event.preventDefault();
        opener = link;
        const image = dialog.querySelector("[data-zoom-image]");
        image.src = link.href;
        image.alt = link.querySelector("img")?.alt || "";
        dialog.showModal();
      }),
    );
    dialog
      .querySelector("[data-close-zoom]")
      .addEventListener("click", () => dialog.close());
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener("close", () => opener?.focus());
  }
});
